import React, { Suspense } from 'react';
import { Feedback } from '../../../Feedback';
import { Container } from './Container';
import { Header } from './Header';
import { Main } from './Main';
import { MainColumn } from './MainColumn';

export type PageLayoutProps = {
  header?: React.ReactNode;
  children?: React.ReactNode;
  actionpanel?: React.ReactNode;
  footer?: React.ReactNode;
};

export function PageLayout({
  header,
  children,
  actionpanel,
  footer,
}: PageLayoutProps) {
  return (
    <Container>
      <Header>{header}</Header>
      <Main>
        <MainColumn>{children}</MainColumn>
        {actionpanel}
      </Main>
      <footer>{footer}</footer>
      <Suspense fallback={null}>
        <Feedback />
      </Suspense>
    </Container>
  );
}
